var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * API services for the Proposal Detail feature
 */
import api from '@utils/axios';
import { convertProposalRequestApiInternalProposalPath } from '@routes';
import { mapProposalResponseToProposal, mapProposalUpdateToApiRequest } from './mapper';
/**
 * Fetches proposal detail data from the API
 * @param id - The proposal ID
 * @returns Promise with the proposal data
 */
export function getProposalDetail(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(`/api/internal/proposals/${id}`);
            return mapProposalResponseToProposal(response.data);
        }
        catch (error) {
            console.error('Error fetching proposal detail:', error);
            throw error;
        }
    });
}
/**
 * Converts a proposal request into an ordinary draft proposal
 * @param id - The proposal ID
 * @returns Promise with the conversion result
 */
export function convertProposalRequest(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.post(convertProposalRequestApiInternalProposalPath(id));
            return response.data;
        }
        catch (error) {
            console.error('Error converting proposal request:', error);
            throw error;
        }
    });
}
/**
 * Updates a proposal with new data
 * @param id - The proposal ID
 * @param proposalUpdate - The data to update
 * @returns Promise with the updated proposal data
 */
export function updateProposal(id, proposalUpdate) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const mappedUpdate = mapProposalUpdateToApiRequest(proposalUpdate);
            const response = yield api.patch(`/api/internal/proposals/${id}`, {
                proposal: mappedUpdate
            });
            return mapProposalResponseToProposal(response.data);
        }
        catch (error) {
            console.error('Error updating proposal:', error);
            throw error;
        }
    });
}
